import axios from "axios";
export function cloudbannerAPI(config, callback, errorcallback){
  const URL = process.env.REACT_APP_BASE_URL+'getPage4Block12';
    axios.get(URL, config)
    .then(res => {
      //do something
     // console.log("cloud api working");
      if(callback != null){
         callback(res);
      }
    })
    .catch(err => {
      // catch error
      if(errorcallback != null){
       // console.log("cloud not api working");
         errorcallback(err);
      }
    })
}
export function cloudtoolsAPI(config, callback, errorcallback){
  const URL = process.env.REACT_APP_BASE_URL+'getPage7Block2';
  axios.get(URL, config)
  .then(res => {
    //do something
  //  console.log("cloud tools technology api working");
    if(callback != null){
       callback(res);
    }
  })
  .catch(err => {
    // catch error
    if(errorcallback != null){
       errorcallback(err);
    }
  })
}
export function cloudServiceAPI(config, callback, errorcallback){
  const URL = process.env.REACT_APP_BASE_URL+'getPage4Block11';
  axios.get(URL, config)
  .then(res => {
    //do something
   // console.log("cloud service api working");
    if(callback != null){
       callback(res);
    }
  })
  .catch(err => {
    // catch error
    if(errorcallback != null){
       errorcallback(err);
    }
  })
}
export function cloudPortfolioAPI(config, callback, errorcallback){
  const URL = process.env.REACT_APP_BASE_URL+'getPage7Block4';
  axios.get(URL, config)
  .then(res => {
    //do something
   // console.log("cloud portfolio api working");
    if(callback != null){
       callback(res);
    }
  })
  .catch(err => {
    // catch error
    if(errorcallback != null){
       errorcallback(err);
    }
  })
}